import * as React from 'react';
import ouiStyle from '@goldwasserexchange/oui-style';
import { listInputElementLinesContext } from './context';
export function ListInputElementLinesProvider(props) {
    var _a = props.elementLines, elementLines = _a === void 0 ? ouiStyle.Constants.linesDefault : _a, children = props.children;
    return (React.createElement(listInputElementLinesContext.Provider, { value: elementLines }, children));
}
